import { render, staticRenderFns } from "./NavigationDrawerItem.vue?vue&type=template&id=74724073&scoped=true&"
import script from "./NavigationDrawerItem.vue?vue&type=script&lang=ts&"
export * from "./NavigationDrawerItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74724073",
  null
  
)

export default component.exports